import AspectIcon from './AspectIcon'

export default AspectIcon
